export default __webpack_public_path__ + "static/media/Group9771.7653e528.svg";